import React, { useState } from "react";
import styled, { ThemeProvider } from "styled-components";
import { DarkTheme } from "./Themes";
import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";
import BigTitlte from "../subComponents/BigTitlte";

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 6rem;
`;

const ContactFormContainer = styled.div`
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 80%;
  max-width: 600px;
  border-radius: 10px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
  margin-top: 4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FormTitle = styled.h2`
  margin-bottom: 2rem;
  font-size: 2rem;
  text-align: center;
`;

const Input = styled.input`
  padding: 1rem;
  margin: 1rem 0;
  width: 100%;
  border: 2px solid ${(props) => props.theme.text};
  border-radius: 5px;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.primary};
  }
`;

const TextArea = styled.textarea`
  padding: 1rem;
  margin: 1rem 0;
  width: 100%;
  height: 150px;
  border: 2px solid ${(props) => props.theme.text};
  border-radius: 5px;
  background-color: ${(props) => props.theme.body};
  color: ${(props) => props.theme.text};
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.primary};
  }
`;

const SubmitButton = styled.button`
  padding: 1rem 2rem;
  margin-top: 1rem;
  background-color: ${(props) => props.theme.primary};
  color: ${(props) => props.theme.body};
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.secondary};
  }
`;

const ContactPage = () => {
  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
        <BigTitlte text="Get In Touch" top="10%" right="20%" />

        <ContactFormContainer>
          <FormTitle>If You Have Any Query or Doubt, Reach Out to Me...</FormTitle>
          <form
            action="https://api.web3forms.com/submit"
            method="POST"
          >
            {/* Hidden Access Key for Web3Forms */}
            <input type="hidden" name="access_key" value="eece40da-61c8-4bca-aa41-a08a0c9022fd" />

            <Input
              type="text"
              name="name"
              placeholder="Your Name"
              required
            />
            <Input
              type="email"
              name="email"
              placeholder="Your Email"
              required
            />
            <TextArea
              name="message"
              placeholder="Your Message"
              required
            />
            <SubmitButton type="submit">Send Message</SubmitButton>
          </form>
        </ContactFormContainer>
      </Box>
    </ThemeProvider>
  );
};

export default ContactPage;
